'use client';

import { Box, ChevronArrow, Text } from '@instamenu/ui-system-next';
import * as styles from './address-select.css';
import type { Address } from '@instamenu/context-user';
import { useCheckoutContext } from '@instamenu/context-checkout';
import { themeVars } from '@instamenu/ui-vanilla-extract';
import { MapPin } from 'lucide-react';

type AddressButtonProps = {
  address?: Address;
  isOpen: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const AddressButton = ({ address, isOpen, ...rest }: AddressButtonProps) => {
  const checkout = useCheckoutContext();
  return (
    <div className={styles.selectButton} {...rest}>
      <Box css={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <MapPin size={28} color={themeVars.color.brand} />
        <Text variant="caption2" className={styles.textAddress}>
          {address
            ? address.line1
            : checkout?.addresses.book.length
              ? 'Select an address'
              : 'Enter your address'}
        </Text>
      </Box>
      <ChevronArrow isOpen={isOpen} />
    </div>
  );
};
